import { render, staticRenderFns } from "./CourseModal.vue?vue&type=template&id=c6e27760&"
import script from "./CourseModal.vue?vue&type=script&lang=js&"
export * from "./CourseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports